import { Editor } from '@tinymce/tinymce-react';

export function TextEditor({text, setText}) {
  const handleBlur = (editor) => setText(editor.getContent())
	return (
		<Editor
			apiKey='7o5au9v0uhuu5abunho39z4aodtpum8vebvscy08bfde1omz'
			init={{
				branding: false,
				plugins: [
					'accordion',
					'anchor',
					'autolink',
					'autoresize',
					'charmap',
					'code',
					'emoticons',
					'fullscreen',
					'help',
					'image',
					'link',
					'lists',
					'media',
					'preview',
					'searchreplace',
					'table',
				],
				toolbar: 'undo redo | blocks | fontsizeinput | bold italic underline strikethrough | forecolor backcolor | link image media table | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
				menubar: 'edit insert format table view help',
				skin: 'small',
				content_css: 'material-outline',
				icons: 'material',
				autoresize_bottom_margin: 10,
			}}
			initialValue={text}
			onBlur={(e) => handleBlur(e.target)}
		/>
	);
}